import type { FC } from 'react';
import crownImage from 'src/images/pngs/campaigns/beat-the-price-hike/crown.png';
import arrowImage from 'src/images/svgs/campaigns/beat-the-price-hike/arrow.svg';
import { StyledArrowImage, StyledBlock, StyledBlockContent, StyledBlockTitle, StyledContainer, StyledCrownImage } from './price-hike.styles';
import type { PriceHikeProps } from './price-hike.types';
export const PriceHike: FC<PriceHikeProps> = ({
  originalPrice,
  hikedPrice,
  symbol
}) => <StyledContainer data-sentry-element="StyledContainer" data-sentry-component="PriceHike" data-sentry-source-file="price-hike.tsx">
    <StyledCrownImage src={crownImage} data-sentry-element="StyledCrownImage" data-sentry-source-file="price-hike.tsx" />
    <Block title="Current monthly price" currency={symbol} value={originalPrice} data-sentry-element="Block" data-sentry-source-file="price-hike.tsx" />
    <StyledArrowImage src={arrowImage} data-sentry-element="StyledArrowImage" data-sentry-source-file="price-hike.tsx" />
    <Block title="Monthly price on June 16th" currency={symbol} value={hikedPrice} data-sentry-element="Block" data-sentry-source-file="price-hike.tsx" />
  </StyledContainer>;
const Block = ({
  title,
  value,
  currency
}: {
  title: string;
  value: string;
  currency: string;
}) => <StyledBlock data-sentry-element="StyledBlock" data-sentry-component="Block" data-sentry-source-file="price-hike.tsx">
    <StyledBlockTitle data-sentry-element="StyledBlockTitle" data-sentry-source-file="price-hike.tsx">{title}</StyledBlockTitle>
    <StyledBlockContent data-sentry-element="StyledBlockContent" data-sentry-source-file="price-hike.tsx">
      {currency}
      {value} <span>per month</span>
    </StyledBlockContent>
  </StyledBlock>;